// extracted by mini-css-extract-plugin
export default {"outerContainer":"OnlyShowIfDesktop_outerContainer__ApONL","textbox":"OnlyShowIfDesktop_textbox__YR4PR"};